export const wholeNumber = (value) => {
  if (typeof value === 'string') {
    return parseInt(value.replace('.', ''));
  } else if (typeof value === 'number' && value.toString().includes('.')) {
    return parseInt(value.toString().replace('.', ''));
  } else {
    return value;
  }
}

export const money = (value, currencySymbol = '$') => {
  return `${currencySymbol}${(value / 100).toFixed(2)}`;
}

export const deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
}